<script>
    import ColorPicker from "$lib/utility/ColorPicker.svelte";
    import { palette } from "$lib/image/palette";

    const { active, index, primary } = palette;

    function updateColor() {

    }
</script>

<ColorPicker bind:color={$primary} on:change={updateColor} />
